import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default (options = {}) => ({
  swiper: null,
  handleResize: null,
  currentBreakpoint: null,

  defaults: {
    enabledAt: {
      mobile: true,
      tablet: true,
      desktop: true,
    },
    slidesPerView: {
      mobile: 1.1,
      tablet: 2.2,
      desktop: 3.4,
    },
    spaceBetween: {
      mobile: 16,
      tablet: 16,
      desktop: 16,
    },
  },

  init() {
    this.$nextTick(() => {
      this.handleResize = this.debounce(() => {
        this.update();
      }, 150);

      this.update();

      window.addEventListener('resize', this.handleResize);
    });
  },

  getBreakpoint() {
    const width = window.innerWidth;

    if (width >= 1024) {
      return 'desktop';
    }

    if (width >= 768) {
      return 'tablet';
    }

    return 'mobile';
  },

  getConfig() {
    return {
      ...this.defaults,
      ...options,
      enabledAt: {
        ...this.defaults.enabledAt,
        ...(options.enabledAt || {}),
      },
      slidesPerView: {
        ...this.defaults.slidesPerView,
        ...(options.slidesPerView || {}),
      },
      spaceBetween: {
        ...this.defaults.spaceBetween,
        ...(options.spaceBetween || {}),
      },
    };
  },

  shouldEnable() {
    const config = this.getConfig();
    const breakpoint = this.getBreakpoint();

    return !!config.enabledAt[breakpoint];
  },

  update() {
    const shouldEnable = this.shouldEnable();
    const breakpoint = this.getBreakpoint();

    if (shouldEnable && !this.swiper) {
      this.initSlider();
      return;
    }

    if (!shouldEnable && this.swiper) {
      this.destroySlider();
      return;
    }

    if (shouldEnable && this.swiper && this.currentBreakpoint !== breakpoint) {
      this.destroySlider();
      this.initSlider();
    }
  },

  initSlider() {
    const swiperEl = this.$refs.swiper;
    if (!swiperEl) return;
  
    const config = this.getConfig();
    const breakpoint = this.getBreakpoint();
  
    const hasNavigation = this.$refs.prev && this.$refs.next;
  
    this.swiper = new Swiper(swiperEl, {
      slidesPerView: config.slidesPerView[breakpoint],
      spaceBetween: config.spaceBetween[breakpoint],
      grabCursor: true,
      watchOverflow: true,
      loop: false,
      observer: true,
      observeParents: true,
      ...(hasNavigation
        ? {
            navigation: {
              prevEl: this.$refs.prev,
              nextEl: this.$refs.next,
            },
          }
        : {}),
      ...(options.swiper || {}),
    });
  },

  destroySlider() {
    if (!this.swiper) {
      return;
    }

    this.swiper.destroy(true, true);
    this.swiper = null;
    this.currentBreakpoint = null;
  },

  destroy() {
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize);
    }

    this.destroySlider();
  },

  debounce(callback, delay = 150) {
    let timeout;

    return (...args) => {
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        callback(...args);
      }, delay);
    };
  },
});